import { render, staticRenderFns } from "./Appdev.vue?vue&type=template&id=18642fc6&scoped=true"
import script from "./Appdev.vue?vue&type=script&lang=js"
export * from "./Appdev.vue?vue&type=script&lang=js"
import style0 from "./Appdev.vue?vue&type=style&index=0&id=18642fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18642fc6",
  null
  
)

export default component.exports